import { deterministicIndex } from './stable.js';

export interface TemplateDefinition {
  key: string;
  variants: readonly string[];
}

export function selectTemplateVariant(
  template: TemplateDefinition,
  seedParts: readonly string[],
): string {
  if (template.variants.length === 0) {
    throw new Error(`Template ${template.key} has no variants`);
  }
  const index = deterministicIndex([...seedParts, template.key].join('|'), template.variants.length);
  const selected = template.variants[index];
  if (selected === undefined) throw new Error('Deterministic index out of range');
  return selected;
}
